
import React, { useState } from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

const AboutSection = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section id="about" className="py-16 px-6">
      <div className="container max-w-5xl mx-auto">
        <div className="mb-12 text-center">
          <h2 className="text-sage-800 mb-2">About Me</h2>
          <div className="w-24 h-1 bg-sage-300 mx-auto"></div>
        </div>
        
        <Card className="border-none shadow-lg bg-white rounded-xl overflow-hidden">
          <CardContent className="p-8">
            <div className="relative mb-4">
              <span className="font-handwriting text-5xl text-sage-200 opacity-50 absolute -top-6 -left-4">"</span>
            </div>
            
            <div className="space-y-6 text-lg relative z-10">
              <p>
                As a Psychology graduate with a collateral in sociology and anthropology, I've always been fascinated by the way people think, interact, and navigate systems.
              </p>
              
              <Collapsible open={isOpen} onOpenChange={setIsOpen} className="md:hidden">
                <CollapsibleContent className="space-y-6">
                  <p>
                    Growing up around a dental office, I witnessed firsthand the power of presence, tone, and trust in professional settings—lessons that stay with me to this day.
                  </p>
                  
                  <p>
                    My professional journey has taken me through academia, insurance, and dental care, and I've approached each transition with adaptability and genuine enthusiasm. What connects these experiences is my passion for creating environments where people feel valued and processes flow efficiently. I've also begun exploring the role of AI in supporting communication, analysis, and workflow automation—especially where psychology and people systems intersect.
                  </p>
                  
                  <p>
                    I thrive in roles where human connection and systematic thinking intersect. Whether I'm guiding clients through complex insurance options, supporting behavioral research, or improving office workflows, I bring the same dedication to both the people and the process.
                  </p>
                </CollapsibleContent>
                
                <div className="pt-4 flex justify-center md:hidden">
                  <CollapsibleTrigger asChild>
                    <Button variant="outline" className="flex items-center gap-2">
                      {isOpen ? (
                        <>
                          <span>Read Less</span> 
                          <ChevronUp className="h-4 w-4" />
                        </>
                      ) : (
                        <>
                          <span>Read More</span> 
                          <ChevronDown className="h-4 w-4" />
                        </>
                      )}
                    </Button>
                  </CollapsibleTrigger>
                </div>
              </Collapsible>
              
              <div className="hidden md:block space-y-6">
                <p>
                  Growing up around a dental office, I witnessed firsthand the power of presence, tone, and trust in professional settings—lessons that stay with me to this day.
                </p>
                
                <p>
                  My professional journey has taken me through academia, insurance, and dental care, and I've approached each transition with adaptability and genuine enthusiasm. What connects these experiences is my passion for creating environments where people feel valued and processes flow efficiently. I've also begun exploring the role of AI in supporting communication, analysis, and workflow automation—especially where psychology and people systems intersect.
                </p>
                
                <p>
                  I thrive in roles where human connection and systematic thinking intersect. Whether I'm guiding clients through complex insurance options, supporting behavioral research, or improving office workflows, I bring the same dedication to both the people and the process.
                </p>
              </div>
              
              <div className="pt-4">
                <p className="font-handwriting text-2xl text-sage-600">Payton Hunter</p>
              </div>
              
              <div className="relative mb-4">
                <span className="font-handwriting text-5xl text-sage-200 opacity-50 absolute -bottom-20 -right-4">"</span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default AboutSection;
